module.exports = __webpack_public_path__ + "img/category-skill-game-hover.d42a38e1.png";